import { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Box from '@mui/material/Box';
import CheckIcon from '@mui/icons-material/Check';
import PaletteIcon from '@mui/icons-material/Palette';
import { useThemeSwitch } from './themes/ThemeContext';
import { themeNames } from './themes';

const themeDots = {
  current: '#19d0ef',
  swiss: '#0a2e5c',
  neobank: '#7c3aed',
  warm: '#c8913a',
};

function ThemeSwitcher() {
  const [anchorEl, setAnchorEl] = useState(null);
  const { themeKey, switchTheme } = useThemeSwitch();
  const theme = useTheme();
  const open = Boolean(anchorEl);

  const handleSelect = (key) => {
    switchTheme(key);
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        size="small"
        onClick={(e) => setAnchorEl(e.currentTarget)}
        startIcon={<PaletteIcon sx={{ fontSize: 16 }} />}
        sx={{
          color: 'text.primary',
          bgcolor: 'background.paper',
          border: 1,
          borderColor: 'divider',
          borderRadius: '12px',
          textTransform: 'none',
          fontSize: '12px',
          px: 1.5,
          py: 0.5,
          minHeight: 0,
          lineHeight: 1.5,
          minWidth: 'auto',
          '&:hover': {
            bgcolor: 'action.hover',
            borderColor: 'primary.main',
          },
        }}
      >
        {themeNames[themeKey] || 'Theme'}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{
          paper: {
            sx: {
              minWidth: 180,
              mt: 0.5,
            },
          },
        }}
      >
        {Object.entries(themeNames).map(([key, name]) => (
          <MenuItem
            key={key}
            selected={key === themeKey}
            onClick={() => handleSelect(key)}
            sx={{ fontSize: theme.typography.body2.fontSize }}
          >
            <ListItemIcon sx={{ minWidth: 28 }}>
              <Box
                sx={{
                  width: 12,
                  height: 12,
                  borderRadius: '50%',
                  bgcolor: themeDots[key] || '#888',
                }}
              />
            </ListItemIcon>
            <ListItemText>{name}</ListItemText>
            {key === themeKey && (
              <CheckIcon sx={{ fontSize: 16, ml: 1, color: 'primary.main' }} />
            )}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

export default ThemeSwitcher;
